<template>
    <div class="signUp">
        <transition name="slide-sort">
            <div class="aaSignupResult" v-if="datatype == 2">
                <div class="box">
                    <div class="result">
                        <div class="success">
                            <div class="title">
                                <!-- <van-icon name="checked" /> -->
                                <img :src="successimg" alt="" style="width: 25px;height: 25px;margin-right: 15px;">
                                <span class="name" style="color: #fff;font-size: 24px;">签到完成</span>
                            </div>
                            <div class="tip">{{ eventinfo.result ? eventinfo.result : '请按秩序入场' }}</div>
                        </div>
                    </div>
                    <div class="ticket-activity">
                        <div class="activity-detail">
                            <div class="title texts-ellipse">{{ eventinfo.title }}</div>
                            <div class="datatime">{{ eventinfo.begintime }} - {{ eventinfo.endtime }}</div>
                            <div class="addr text-ellipse">{{ eventinfo.address }}</div>
                        </div>
                        <img :src="dividingLine" alt="" class="dividing-line">
                        <div class="ticket-detail">
                            <div class="ticketItem">
                                <div class="nameBox">
                                    <div class="ticketName">{{ eventinfo.colnamearr && eventinfo.colnamearr.length > 2 ?
                                        eventinfo.colnamearr[2]
                                        : '' }}</div>
                                </div>
                                <!-- <div class="participant">
                                    <div class="left">参加人</div>
                                    <div class="right">
                                        <div class="textItem" >
                                            <p class="name">{{ eventinfo.joinername }}</p>
                                            <p class="phoneNum">{{ eventinfo.joinermobile }}</p>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="ticketNum">
                                    <div class="left">姓名</div>
                                    <div class="right">
                                        <div class="item">
                                            <p>{{ eventinfo.joinername }}</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="ticketNum">
                                    <div class="left">电话</div>
                                    <div class="right">
                                        <div class="item">
                                            <p>{{ eventinfo.joinermobile }}</p>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="ticketNum">
                                    <div class="left">公司</div>
                                    <div class="right">
                                        <div class="item">
                                            <p>{{ eventinfo.colnamearr && eventinfo.colnamearr.length > 0 ?
                                                eventinfo.colnamearr[0] : '--' }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="ticketNum">
                                    <div class="left">职务</div>
                                    <div class="right">
                                        <div class="item">
                                            <p>{{ eventinfo.colnamearr && eventinfo.colnamearr.length > 1 ?
                                                eventinfo.colnamearr[1] : '--' }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="statusBox">
                                    <p>状态</p>
                                    <p
                                        :class="{ 'status1': eventinfo.signstatus === 1, 'status2': eventinfo.signstatus === 2 }">
                                        已签到</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mycontainer" style="margin-top: -24px;" v-if="datatype == 1">
                <div class="startbox">
                    <img :src="titleimg" alt="" class="titleimg">
                    <div class="result">
                        <div class="title" style="text-align: left;">
                            欢迎回家！
                        </div>
                        <div class="title firsttitle">第七届中国董秘峰会暨第二届金鹰董秘榜单颁奖典礼，将于2025年11月14日13:30，在深圳市福田区·好日子皇冠假日酒店盛大启幕！
                        </div>
                        <div class="title firsttitle" >与行业顶尖智慧同频，共推中国资本市场迈向更高水平！</div>
                    </div>
                    <div class="ticket-activity">
                        <div class="title bigtitle">峰会签到还未开始 敬请期待！</div>
                    </div>
                </div>
            </div>

            <div class="mycontainer" style="margin-top: -24px;" v-if="datatype == 3">
                <div class="box">
                    <img :src="titleimg" alt="" class="titleimg">
                    <div class="result">
                        <div class="title">
                            感谢您的参与
                        </div>
                        <div class="title" style="margin-bottom: 20px;">第七届中国董秘峰会已经圆满结束！</div>
                        <div class="title">欢迎您加入董秘俱乐部</div>
                        <div class="title">与我们共同期待下一届中国董秘峰会！</div>
                    </div>
                    <div class="ticket-activity" >
                        <img :src="qrcodeimg" alt="" class="qrcodeimg">
                        <div class="title">扫码关注公众号</div>
                    </div>
                </div>
            </div>
        </transition>
        <!-- 验证码弹窗 -->
        <!-- <van-popup v-model="showPopup" class="custom-popup" :close-on-click-overlay="false">
            <div class="popup-header">
                <h3 class="popup-title">验证码</h3>
            </div>
            <div class="code-input">
                <van-field v-model="verificationCode" class="code-field" placeholder="请输入验证码" clearable center />
            </div>
            <van-button class="submit-btn" type="primary" block @click="verifyCode">
                确认
            </van-button>
        </van-popup> -->
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import { signTicketByAdminHost } from 'api/activeTools'
export default {
    name: 'signUp',
    data() {
        return {
            eventinfo: {
                title: '',
                coveratturlid: '',
                begintime: '',
                endtime: '',
                address: '',
                ticketNumList: [],
                result: '',
                statusname: '',
                status: 0
            },
            ticketlist: [],
            show: false,
            shoiceNum: 0,
            eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
            ticketid: this.$route.query.ticketid ? this.$route.query.ticketid : '',
            pageShow: false,
            checkList: [],
            allChoiceResult: false,
            isVerified: false, // 是否验证通过
            showPopup: true,   // 初始显示弹窗
            verificationCode: '',
            countdown: 0,
            timer: null,
            datatype: 0,
            dividingLine: require('@/common/images/activeTools/dividing_line@2x.png'),
            afterimg: require('@/common/images/activeTools/signbefore.jpg'),
            beforeimg: require('@/common/images/activeTools/signbgafter.jpg'),
            successimg: require('@/common/images/activeTools/signsuccess.png'),
            bgimg: require('@/common/images/activeTools/signbg.jpg'),
            titleimg: require('@/common/images/activeTools/signtitle.png'),
            qrcodeimg: require('@/common/images/activeTools/qrcode.png'),
        }
    },
    mounted() {
        document.title = '活动信息'
        this.verifyCode()
    },
    methods: {
        // 验证验证码
        verifyCode() {
            // if (!this.verificationCode) {
            //     this.$toast('请输入验证码');
            //     return;
            // }

            this.setLoading(true)

            // API调用
            let formData = new FormData()
            formData.append('eventid', this.eventid)
            formData.append('ticketid', this.ticketid)
            // formData.append('ckpass', this.verificationCode)
            signTicketByAdminHost({
                data: formData,
                success: data => {
                    this.setLoading(false)
                    if (data.code == '302') {
                        this.setLoading(false)
                        this.datatype = 1

                    } else if (data.code == '303') {
                        this.setLoading(false)
                        this.datatype = 3
                    } else if (data.code == '000') {
                        this.isVerified = true;
                        this.showPopup = false;
                        this.datatype = 2
                        this.setLoading(false)
                        this.$toast.success('签到成功');
                        this.show = true
                        this.eventinfo = data.data
                        this.eventinfo.colnamearr = data.data.colvaluelist ? data.data.colvaluelist.split(',') : []
                    } else {
                        this.datatype = 0
                        this.setLoading(false)
                        this.$toast(data.msg || '签到失败，请重新扫描');
                        this.verificationCode = '';
                    }
                },
                error: (data) => {
                    if (data.code == '302') {
                        this.setLoading(false)
                        this.datatype = 1

                    } else if (data.code == '303') {
                        this.setLoading(false)
                        this.datatype = 3
                    } else {
                        this.datatype = 0
                        this.setLoading(false)
                        this.$toast(data.msg || '签到失败，请重新扫描');
                        this.verificationCode = '';
                    }
                }
            })
        },
        anewSignup() {
            this.show = false
            this.eventinfo.ticketNumList = []
        },
        allChoice() {
            if (!this.allChoiceResult) {
                this.allChoiceResult = true
                this.ticketlist.forEach(obj => {
                    obj.check = true
                })
            } else {
                this.allChoiceResult = false
                this.ticketlist.forEach(obj => {
                    obj.check = false
                })
            }
        },

        oneTicketMsg(item) {
            this.$router.push({ name: 'oneTicketDetails', query: { eventid: this.eventid, itemid: item.itemid } })
        },
        checkAtyMsg() {
            this.$router.push({ name: 'ActivityDetail', query: { eventid: this.eventid } })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'ticketlist': {
            handler(newV) {
                let num = 0
                newV.forEach(obj => {
                    if (obj.check) {
                        num++
                    }
                })
                this.shoiceNum = num
            },
            deep: true
        }
    },
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";

.signUp {
    width: 100vw;
    max-width: 100vw;
}

.custom-popup {
    border-radius: 16px;
    padding: 25px 20px;
    width: 100%;
    max-width: 70vw;
}

.popup-header {
    text-align: center;
    margin-bottom: 20px;
}

.popup-title {
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 8px;
}

.popup-desc {
    font-size: 14px;
    color: #969799;
}

.code-input {
    margin: 20px 0;
}

.code-field {
    margin-bottom: 15px;
}

.countdown-btn {
    color: #1989fa;
}

.countdown-btn:disabled {
    color: #c8c9cc;
}

.submit-btn {
    margin-top: 20px;
    font-size: 24px;
}

.tips {
    font-size: 12px;
    color: #969799;
    margin-top: 10px;
    text-align: center;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.aaSignupResult {
    background: $c-global;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    overflow-y: auto;
     width: 100%;
    height: 100vh;
    min-height: 100vh;
    /* 兼容性备用 */
    overflow: hidden;
    background-image: url('../../common/images/activeTools/signbg.jpg');
    background-size: cover;
    /* 关键：保持比例覆盖整个容器 */
    background-position: center center;
    /* 居中显示 */
    background-repeat: no-repeat;
    /* 防止平铺 */
    background-attachment: fixed;

    .result {
        font-size: 0.36rem;
        padding: 1rem 0 0.8rem 0;
        text-align: center;

        .title {
            display: flex;
            align-items: center;
            justify-content: center;

            .name {
                font-weight: 600;
                color: #333333;
            }

            .van-icon {
                font-size: 0.5rem;
                margin-right: 0.18rem;
            }
        }

        .tip {
            color: #fff;
            font-size: 0.34rem;
            margin-top: 0.4rem;
        }

        .success {
            .van-icon {
                color: #0ABF53;
            }
        }

        .fail {
            .van-icon {
                color: #FF4747;
            }
        }
    }

    .ticket-activity {
        margin: 0 0.6rem;
        margin-top: 40px;

        .activity-detail {
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            padding: 0.4rem 0.28rem 0.32rem 0.18rem;
            background: #fff;
            border-radius: 0.1rem 0.1rem 0 0;

            .title {
                font-size: 0.28rem;
                line-height: 0.32rem;
                color: #303133;
                margin-bottom: 0.2rem;
                font-weight: 600;
            }

            .datatime,
            .addr {
                color: #666666;
                font-size: 0.24rem;
                line-height: 0.28rem;
                margin-top: 0.12rem;
            }
        }

        .dividing-line {
            // width: 6.3rem;
            width: 100%;
            height: 0.28rem;
            display: block;
        }

        .ticket-detail {
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            padding: 0rem 0.28rem 0.6rem 0.28rem;
            background: #fff;
            border-radius: 0 0 0.1rem 0.1rem;

            .ticket-summary {
                color: #333333;
                font-size: 0.3rem;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;

                .value {
                    .num {
                        font-size: 0.2rem;
                        color: #999999;
                        margin-right: 0.32rem;
                    }

                    .item {
                        margin-bottom: 0.1rem;
                    }

                }
            }

            .ticketItem {
                .line {
                    border-bottom: 0.02rem dashed #999999;
                    padding: 0.4rem 0 0.2rem;
                }

                .nameBox {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 0.2rem;
                    padding-bottom: 0.4rem;
                    justify-content: center;

                    .ticketName {
                        font-size: 0.32rem;
                        line-height: 0.4rem;
                        font-weight: 600;
                    }

                    .price {
                        display: flex;
                        align-items: center;

                        .ticketType {
                            color: #999999;
                            font-size: 0.2rem;
                            margin-right: 0.32rem;
                        }

                        .priceText {
                            font-size: 0.28rem;
                            color: #333333;
                        }
                    }
                }

                .participant,
                .ticketNum {
                    display: flex;
                    justify-content: space-between;
                    color: #666666;
                    padding-bottom: 0.4rem;
                    font-size: 0.28rem;

                    .left {
                        line-height: 0.4rem;
                    }

                    .right {
                        flex: 1;
                        max-width: calc(100% - 50px);


                        .textItem,
                        .item {
                            display: flex;
                            justify-content: flex-end;

                            p {
                                line-height: 0.4rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }

                            .name {
                                margin-right: 0.5rem;
                            }
                        }
                    }
                }

                .statusBox {
                    display: flex;
                    justify-content: space-between;
                    color: #666666;
                    font-size: 0.28rem;

                    .status1 {
                        color: #0ABF53;
                    }

                    .status2 {
                        color: #FF4747;
                    }
                }
            }
        }
    }

    .paymentResult-btn {
        margin: 0.9rem 0.6rem 0 0.6rem;
        font-size: 0.3rem;
        padding-bottom: 0.32rem;

        .btn {
            height: 0.76rem;
            width: 6.3rem;
            text-align: center;
            line-height: 0.76rem;
            border-radius: 0.4rem;
            box-sizing: border-box;
        }

        .my-ticket {
            color: #fff;
            background: linear-gradient(360deg, rgba(10, 191, 83, 1) 0%, rgba(71, 236, 201, 1) 100%);
        }

        .activity-detail {
            margin-top: 0.32rem;
            border: 1px solid #E5E5E5;
            background: #fff;
        }
    }

    .tc-orange {
        color: #FFA904;
    }

    .tc-red {
        color: #FF4747;
    }

    .tc-green {
        color: #0ABF53;
    }
}

.mycontainer {
    width: 100%;
    height: 100vh;
    min-height: 100vh;
    /* 兼容性备用 */
    overflow: hidden;
    background-image: url('../../common/images/activeTools/signbg.jpg');
    background-size: cover;
    /* 关键：保持比例覆盖整个容器 */
    background-position: center center;
    /* 居中显示 */
    background-repeat: no-repeat;
    /* 防止平铺 */
    background-attachment: fixed;
    /* 固定背景 */

    font-family: PingFang SC, PingFang SC;

    .titleimg {
        width: 90vw;
        margin-left: 5vw;
        margin-top: 110px;
    }

    .result {
        padding-top: 70px;
        padding-bottom: 70px;
        text-align: center;
        font-size: 30px;
        color: #fff;

        .title {
            line-height: 1.5;
        }
    }

    .qrcodeimg {
        width: 180px;
        height: 180px;
    }

    .ticket-activity {
        display: flex;
        justify-content: center;
        flex-direction: column;
        gap: 25px;
        align-items: center;

        .title {
            font-size: 26px;
            color: #fff;
        }

        .bigtitle{
        text-align: center;
         font-size: 32px;
    }
    }

    .startbox .result {
        padding: 60px 40px;
        padding-bottom: 100px;
        font-size: 24px;
        color: #fff;

        .title {
            line-height: 1.8;
            text-align: left;
            letter-spacing: 2px;
        }

        .firsttitle{
            text-indent: 2em;
        }

    }
    
}
</style>